import { api } from '@/plugins/axios'
import type { AxiosResponse } from 'axios'
import type {
  IPayoutAccount,
  ICreatePayoutAccountPayload,
  ICreatePayoutAccountResponse,
  IRefreshSessionResponse,
  IEventPayoutAccountResponse,
  ISetEventPayoutAccountPayload,
  ISyncPayoutAccountResponse,
} from '../types'

// List all payout accounts
export const getPayoutAccounts = async (): Promise<IPayoutAccount[]> => {
  const response = await api.get<never, AxiosResponse<IPayoutAccount[]>>('/user/payout-accounts')
  return response.data
}

// Create a new payout account
export const createPayoutAccount = async (
  payload: ICreatePayoutAccountPayload
): Promise<ICreatePayoutAccountResponse> => {
  const response = await api.post<ICreatePayoutAccountPayload, AxiosResponse<ICreatePayoutAccountResponse>>(
    '/user/payout-accounts',
    payload
  )
  return response.data
}

// Delete payout account
export const deletePayoutAccount = async (accountId: number): Promise<void> => {
  await api.delete(`/user/payout-accounts/${accountId}`)
}

// Refresh onboarding session
export const refreshPayoutAccountSession = async (accountId: number): Promise<IRefreshSessionResponse> => {
  const response = await api.post<never, AxiosResponse<IRefreshSessionResponse>>(
    `/user/payout-accounts/${accountId}/refresh`
  )
  return response.data
}

// Get event's payout account
export const getEventPayoutAccount = async (eventId: number): Promise<IEventPayoutAccountResponse> => {
  const response = await api.get<never, AxiosResponse<IEventPayoutAccountResponse>>(`/events/${eventId}/payout-account`)
  return response.data
}

// Set event's payout account
export const setEventPayoutAccount = async ({
  eventId,
  payload,
}: {
  eventId: number
  payload: ISetEventPayoutAccountPayload
}): Promise<void> => {
  await api.put(`/events/${eventId}/payout-account`, payload)
}

// Sync payout account status from Stripe
export const syncPayoutAccount = async (accountId: number): Promise<ISyncPayoutAccountResponse> => {
  const response = await api.post<never, AxiosResponse<ISyncPayoutAccountResponse>>(
    `/user/payout-accounts/${accountId}/sync`
  )
  return response.data
}
